'use strict';

function AddItemController($scope, $mdDialog, itemTemplates) {
    'ngInject';

    $scope.itemTpls = itemTemplates;
    $scope.btnDisabled = true;

    $scope.selectedItemTpl = function(itemTpl) {
        $mdDialog.hide({
            itemTpl: itemTpl
        });
    };

    $scope.querySearch = function(text) {
        let matches = this.itemTpls.filter(pt => {
            let nameMatch = pt.name.toLowerCase().indexOf(
                text.toLowerCase()
            ) > -1;
            let idMatch = pt.id.toString().indexOf(text) > -1;
            return nameMatch || idMatch;
        });
        console.debug(matches);
        return matches;
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.updateFormStatus = function() {
        if ($scope.itemTpl) {
            $scope.btnDisabled = false;
        } else {
            $scope.btnDisabled = true;
        }
    };
}

export default AddItemController;
